var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center"}},[_c('span',{staticClass:"headline ml-4"},[_vm._v(_vm._s(_vm.conversationType))]),_c('v-spacer'),_c('refresh-btn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }